/* eslint-disable import/prefer-default-export */

import { COMPOSER } from 'src/store/ActionTypes';

export const fetchSegments = (query) => ({
  type: COMPOSER.FETCH_SEGMENTS,
  payload: query,
});

export const addSlide = () => ({
  type: COMPOSER.ADD_SLIDE,
});

export const removeSlide = (index) => ({
  type: COMPOSER.REMOVE_SLIDE,
  payload: index,
});

export const moveSlide = (fromIndex, toIndex) => ({
  type: COMPOSER.MOVE_SLIDE,
  payload: {
    fromIndex,
    toIndex,
  },
});

export const fetchStories = (query) => ({
  type: COMPOSER.FETCH_STORIES,
  payload: query,
});

export const selectSlide = (index) => ({
  type: COMPOSER.SELECT_SLIDE,
  payload: index,
});

export const selectView = (index, view) => ({
  type: COMPOSER.SELECT_VIEW,
  payload: {
    index,
    view,
  },
});

export const selectSegmentIds = (index, segmentIds) => ({
  type: COMPOSER.SELECT_SEGMENT_IDS,
  payload: {
    index,
    segmentIds,
  },
});

export const selectImageFile = (index, imageFile) => ({
  type: COMPOSER.SELECT_IMAGE_FILE,
  payload: {
    index,
    imageFile,
  },
});

export const updateSlide = (index, slide) => ({
  type: COMPOSER.UPDATE_SLIDE,
  payload: {
    index,
    slide,
  },
});

export const addStory = (datasetId, name, slides) => ({
  type: COMPOSER.ADD_STORY,
  payload: {
    datasetId,
    name,
    slides,
  },
});

export const editStory = (storyId, datasetId, name, slides) => ({
  type: COMPOSER.EDIT_STORY,
  payload: {
    storyId,
    datasetId,
    name,
    slides,
  },
});

export const deleteStory = (storyId) => ({
  type: COMPOSER.DELETE_STORY,
  payload: storyId,
});

export const unset = (payload) => ({
  type: COMPOSER.UNSET,
  payload,
});
